import toBits from './to-bits';
export { toBits };
export default {
  toBits: toBits
};